import http from '../utils/http';
import dataAxios from './axios';


export default {
	listBuckets(params = {}) {
		return dataAxios({ 
			url: '/buckets',
			params})
			.then(http.resolveData, http.rejectData);
	},
};



// WEBPACK FOOTER //
// ./src/modules/data/api.js